export default __webpack_public_path__ + "static/acc-opening-banner-desktop-4c833b3dd41ae9e92f84cff63357f86c.jpg";